import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { USERS_DOMAIN } from './constants';

const selectUsersDomain = state => state[USERS_DOMAIN] || initialState;

export const selectUsers = () => createSelector(selectUsersDomain, d => d.users);
export const selectHomeUsers = () => createSelector(selectUsersDomain, d => d.homeUsers);

export const selectWebsiteUsers = () => createSelector(selectUsersDomain, d => d.website?.users ?? []);

export const selectUser = id =>
  createSelector(
    selectUsersDomain,

    //first select from fetchedUsers, then look in d.users (whole pages)
    d => d.fetchedUsers[id] || d.users.find(item => parseInt(item.id, 10) === parseInt(id, 10)),
  );

export const selectUserPaginator = () => createSelector(selectUsersDomain, d => d.paginator);

export const selectWebsiteUserPaginator = () => createSelector(selectUsersDomain, d => d.website?.paginator ?? {});

export const selectUserCount = () => createSelector(selectUsersDomain, d => d.usersCount);

export const selectWebsiteUserCount = () => createSelector(selectUsersDomain, d => d.website?.usersCount ?? 0);

export const selectUserPropertyNames = () => createSelector(selectUsersDomain, d => d.propertyNames);

export const selectCountries = () => createSelector(selectUsersDomain, d => d.countries);

export const selectCompanies = () => createSelector(selectUsersDomain, d => d.companies);

export const selectUserFilter = () => createSelector(selectUsersDomain, d => d.filter);

export const selectFilterSingleValue = name =>
  createSelector(selectUserFilter, d => d?.properties?.find(f => f.key === name)?.value?.[0] ?? null);
export const selectFilterValues = name =>
  createSelector(selectUserFilter, d => d?.properties?.find(f => f.key === name)?.value ?? []);

export const selectAllPermissions = () => createSelector(selectUsersDomain, d => d.permissions);

export const selectWebsiteUser = () => createSelector(selectUsersDomain, d => d.websiteUser);

export const selectWebsiteUserFilter = () => createSelector(selectUsersDomain, d => d.websiteFilter);

export const selectUserHistoryLogs = () => createSelector(selectUsersDomain, d => d.historyLogs);
export const selectUserFilterHistoryLogs = () => createSelector(selectUsersDomain, d => d.filterHistoryLogs);
